export const ProceduresSettings = {
    ShowProcedures: "ShowProcedures"
}